<template>
  <div class="animated fadeIn">
    <Forms ref="frmExpense"
      :title="'CADASTRO DE DESPESAS DIVERSOS'"
      :showHelp="false"
      :showClearButton="false"
      :showSaveButton="false"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row pt-3">
        <div class="col-md-4">
          <label for="cbxInsure"><small class="text-danger">*</small> Obra:</label>
          <autocomplete-z ref="obraRHTypeahead"
                          placeholder="Digite o nome da Obra"
                          iconClass="fas fa-hard-hat"
                          :serializer="(obra) => obra.referencia"
                          :debounceLength="2"
                          :formField="form.obraID"
                          v-on:search="onSearchObra"
                          v-on:changeCode="onChangeCodeObra"/>
        </div>
        <div class="col-md-4">
          <label for="txtInsured"><small class="text-danger">*</small> Responsável:</label>
          <autocomplete-z ref="responsavelTypeahead"
                          placeholder="Digite o nome do Responsável"
                          iconClass="fas fa-users"
                          :serializer="(responsavel) => responsavel.codigo + ' - ' + responsavel.nome"
                          :debounceLength="3"
                          :formField="form.responsavelID"
                          v-on:search="onSearchResponsavel"
                          v-on:changeCode="onChangeCodeResponsavel" />
        </div>
        <div class="col-md-4">
          <label for="cbxInsure"><small class="text-danger">*</small> Regional:</label>
          <div class="input-group">
            <b-form-input type="text"
                          class="col-2 text-upper"
                          style="height: calc(2.09375rem + 2px);"
                          :placeholder="'Código'"
                          v-model="form.secaoRH.value"
                          :size="form.secaoRH.maxlength"
                          :state="form.secaoRH.state"
                          @focus="onClearSection"
                          v-on:change="onChangeCodeSection"
            />&nbsp;
            <b-form-select v-model="form.secaoRHID.value"
                          :options="form.secaoRHID.options" >
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-3">
        <div class="col-md-4">
          <label><small class="text-danger">*</small> Solicitante:</label>
          <autocomplete-z ref="favorecidoTypeahead"
                          placeholder="Digite o nome do Funcionário"
                          iconClass="fas fa-hard-hat"
                          :serializer="(favorecido) => favorecido.codigo + ' - ' + favorecido.nome"
                          :debounceLength="3"
                          :formField="form.favorecidoID"
                          v-on:search="onSearchFavorecido"
                          v-on:changeCode="onChangeCodeFavorecido" />
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import MiscellaneousExpenseAdd from './add.js'
export default MiscellaneousExpenseAdd
</script>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/miscellaneous/add/add.vue